import { AggregateQueryInterval } from "~/modules/filters/types";

// // // //

export const TOKEN_TIMESERIES_INTERVAL_LABELS: Record<
    AggregateQueryInterval,
    string
> = {
    [AggregateQueryInterval.day]: "Day",
    [AggregateQueryInterval.week]: "Week",
    [AggregateQueryInterval.month]: "Month",
    [AggregateQueryInterval.quarter]: "Quarter",
    [AggregateQueryInterval.year]: "Year",
};
